export default "__VITE_ASSET__966db2c4__"